export default __webpack_public_path__ + "static/media/regalxReal03_downloadMT4.254f8f87.png";